export default "__VITE_ASSET__Be06kIn7__"